/* eslint-disable class-methods-use-this, prefer-destructuring, no-undef, no-shadow, no-unused-vars */
class ScrollNextSection {
	constructor() {
		this.btnScrollNextSection = document.getElementById('btn-next-section');
		if (this.btnScrollNextSection) {
			this.init();
		}
	}

	init() {
		this.btnScrollNextSection.addEventListener('click', () => {
			const sections = document.querySelectorAll('section');
		
			let currentSectionIndex = Array.from(sections).findIndex(section => {
				return section.contains(this.btnScrollNextSection);
			});
		
			if (currentSectionIndex !== -1 && currentSectionIndex < sections.length - 1) {
				const nextSection = sections[currentSectionIndex + 1];
		
				// Obtener las coordenadas de la siguiente sección
				const rect = nextSection.getBoundingClientRect();
				
				// Calcular la posición de desplazamiento con el offset de 115px
				const offset = 130;
				const scrollToPosition = rect.top + window.pageYOffset - offset;
		
				// Realizar el scroll suave con el ajuste
				window.scrollTo({
					top: scrollToPosition,
					behavior: 'smooth'
				});
			}
		});
	}
}

export default ScrollNextSection;
